import {
	Component,
	OnInit,
	ViewChild
} from '@angular/core'
import { NgForm } from '@angular/forms'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { ActivatedRoute } from '@angular/router'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { OperationServiceReport } from 'src/app/models/OperationReport'
import { OperationServiceService } from 'src/app/services/operation.service.service'
import { getEnableLegalFundamentation, getIdentifierName, getLoggedUser, getOperationsServiceForReport, getSessionOperationsServiceForReport, setSessionStorageOperationsServiceForReport } from 'src/app/_helpers/LocalStorage'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { ISpecies } from 'src/app/models/Species'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { SpeciesService } from 'src/app/services/species.service'
import { NotificationService } from 'src/app/services/notification.service'
import { startupPuppeteerLoading } from 'src/app/services/puppeteer-server.service'
import { TreeService } from 'src/app/services/tree.service'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { OperationServiceDataToReport } from 'src/app/models/OperationService'

@Component({
	selector: 'app-operation-service-report-arboreal',
	templateUrl: './operation-service-report-arboreal.component.html'
})
export class OperationServiceReportArborealComponent implements OnInit {

	constructor(
		private operationService: OperationServiceService,
		public handlerOperationService: HandlerOperationService,
		public speciesService: SpeciesService,
		public notificationService: NotificationService,
		public treeService: TreeService,
		private routeActive: ActivatedRoute
	) {}

	@ViewChild('form') public form: NgForm
	public reports: Array<OperationServiceReport> = []
	public ViewValidation: ViewValidation = new ViewValidation()

	public species: Array<ISpecies> = []
	public specieInitial: ISpecies
	public speciesScientific: Array<ISpecies> = []
	public handlerOperations: Array<IHandlerOperation> = []

	public companyId: string = localStorage.getItem('companyId')
	public dataForReports: Array<OperationServiceDataToReport> = [];
	public oldReportJson: string = ''
	public sessionUser: UserAdmin = getLoggedUser()
	public assignments: Array<string> = []
	public numberOfPages: Array<string> = []

	public identifierName = getIdentifierName()
	public pendingNumber: number = 0

	public isNotModeEdit: boolean = true
	public changedAnotherData: boolean = false
	public disabledButton: boolean = false
	public enableEditButton: boolean = true
	public enableLegalFundamentation: boolean = getEnableLegalFundamentation()
	public switchProgress: boolean = false
	public isLoading: boolean = true
	public multipleReports: boolean = false
	public showSelectHandleOperations: boolean = false
	public percentReportReceived: number = 0
	public showAddressChangeModal: boolean = false

	public isAdmin: boolean = false

	public permission: boolean = true

	public openModalChoosePrint: boolean = false

	public async ngOnInit(): Promise<void> {
		console.log('On operation service report arboreal')
		this.isAdmin =
			this.sessionUser.roles.includes('GENERAL_ADMIN') ||
			this.sessionUser.roles.includes('CUSTOMER')

		this.setOperationsServiceDataToReports()
		await this.getReports()

		if (!this.multipleReports) {
			this.getHandlerOperations()
			this.getSpecies()
		}
	}

	public async getReports() {

		const parts = this.arrayPartition(this.dataForReports)

		let limitProgressUntilAwaitRequest: number = 0

		for (const part of parts) {
			limitProgressUntilAwaitRequest += Math.floor(part.length / this.dataForReports.length * 100)

			this.progressPercentReceived(limitProgressUntilAwaitRequest)

			try {
				const reports =
					await this.operationService.getOperationReportArboreal(part).toPromise()
				this.reports = [...this.reports, ...reports]
				this.switchProgress = !this.switchProgress
			} catch (err) {
				console.log('Error', err)
				if (parts.length == 1) {
					this.permission = false
					break
				}
			}
		}

		this.reports.forEach(report => {
			report.originalRecommendationsManagement = report.recommendationsManagement
		})


		this.stopProgressPercentReceived()

		if (this.reports.length == 1) {
			const userOwnerWithPermitionUpdate: boolean = Boolean(
				this.reports[0].operatorId === this.sessionUser._id &&
				this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_UPDATE')
			)

			const hasPermitionUpdate = Boolean(
				userOwnerWithPermitionUpdate ||
				this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_UPDATE_ALL')
			)

			this.enableEditButton = Boolean(
				hasPermitionUpdate ||
				this.sessionUser.roles.includes('GENERAL_ADMIN')
			)

			this.enableEditButton = Boolean(
				hasPermitionUpdate ||
				this.sessionUser.roles.includes('GENERAL_ADMIN')
			)

			const { qrCodeImage, ...responseWithoutQrcodeImage } = this.reports[0]

			this.oldReportJson = JSON.stringify(responseWithoutQrcodeImage)
		} else {
			this.enableEditButton = false
			this.multipleReports = true
		}

		this.isLoading = false

		startupPuppeteerLoading(document)
	}

	public arrayPartition(array: Array<OperationServiceDataToReport>) {
		const parts: OperationServiceDataToReport[][] = [];

		for (let i = 0; i < array.length; i += 10) {
			const part = array.slice(i, i + 10)
			parts.push(part)
		}

		return parts
	}

	public progressPercentReceived(limit: number) {

		const switchNow: boolean = this.switchProgress

		const intervalId = setInterval(() => {
			if (switchNow != this.switchProgress || this.percentReportReceived >= limit) {
				clearInterval(intervalId)
			}

			this.percentReportReceived < 99 && this.percentReportReceived++
		}, 280)
	}

	public stopProgressPercentReceived() {
		this.switchProgress = !this.switchProgress
		this.percentReportReceived = 100
	}

	public async getHandlerOperations() {
		const handleOperations: Array<IHandlerOperation> =
			await this.handlerOperationService.list(this.companyId, false).toPromise()

		const operations = handleOperations.map(item => {
			return{
				operation: item.operation,
				_id: item._id,
				legalFundamentation: item.legalFundamentation
			}
		})

		const operationFoInsert = []

		this.reports.forEach(report => {
			report.recommendationsManagement.forEach(recommendationManagement => {
				if (operations.findIndex(operation => operation._id == recommendationManagement.idMongo) === -1) {
					operationFoInsert.push({
						operation: recommendationManagement.operation,
						_id: recommendationManagement.idMongo,
						disabled: true,
						legalFundamentation: recommendationManagement.legalFundamentation
					})
				}
			})
		})

		this.handlerOperations = [...operations, ...operationFoInsert]
	}

	public async getSpecies() {
		this.species = await this.speciesService.getSpeciesSimple().toPromise()

		this.verifySpecies()

		const arrayManipuleSpeciesScientific = [...this.species]

		this.speciesScientific = arrayManipuleSpeciesScientific.sort((a, b) => {
			if (a.nomenclature.scientificName.toLowerCase() < b.nomenclature.scientificName.toLowerCase()) {
				return -1
			}
			return 1
		})
	}

	public verifySpecies() {
		this.reports.forEach(report => {
			const specieActive = this.species.some(specie =>
				specie._id === report.Tree.specieId
			)

			if (!specieActive) {
				this.insertSpecieInSpeciesArray(
					report.Tree.specieId,
					report.Tree.specie,
					report.Tree.popularName,
					report.Tree.botanicalClassification,
					report.Tree.origin,
					report.Tree.specialCategory
				)
			}
		})
	}

	public insertSpecieInSpeciesArray(
		idMongo: string,
		scientificName: string,
		popularName: string,
		botanicalClassification: string,
		origin: string,
		specialCategory: string
	) {
		this.species.push({
			_id: idMongo,
			nomenclature: {
				scientificName,
				popularName,
				botanicalClassification
			},
			characterization: {
				origin
			},
			evaluationComponents: {
				specialCategory
			},
			inactive: true
		})
	}

	public async getPageHeight() {
		let pageHeight = 0

		function findHighestNode(nodesList) {
			for (let i = nodesList.length - 1; i >= 0; i--) {
				if (nodesList[i].scrollHeight && nodesList[i].clientHeight) {
					const elHeight = Math.max(
						nodesList[i].scrollHeight,
						nodesList[i].clientHeight
					)
					pageHeight = Math.max(elHeight, pageHeight)
				}
				if (nodesList[i].childNodes.length) {
					findHighestNode(nodesList[i].childNodes)
				}
			}
		}

		findHighestNode(document.documentElement.childNodes)

		// The entire page height is found
		this.numberOfPages = Array(Math.ceil(pageHeight / 1600))

		for (let index = 1; index <= this.numberOfPages.length; index++) {
			this.numberOfPages[index - 1] = `${index < 10 ? '0' : ''}${index}`
		}
	}

	public hasChangeSpecie(nameSpecie): void {
		const findSpecie = this.species.find(item => {
			return (item.nomenclature.popularName === nameSpecie || item.nomenclature.scientificName === nameSpecie) && !item.inactive
		})

		if (findSpecie) {
			this.reports[0].Tree.specie = findSpecie.nomenclature.scientificName
			this.reports[0].Tree.popularName = findSpecie.nomenclature.popularName
			this.reports[0].Tree.botanicalClassification = findSpecie.nomenclature.botanicalClassification
			this.reports[0].Tree.origin = findSpecie.characterization.origin
			this.reports[0].Tree.specialCategory =
				this.getTreeCategorySpecialWithValue(findSpecie.evaluationComponents.specialCategory)

			this.changedAnotherData = true
		}
	}

	public getIdsOperationManagmentInserted(operationName: string): string {

		return this.handlerOperations.find(handleOperation => {
			return handleOperation.operation === operationName
		})._id
	}

	public deleteOperationManagement(operationSelected): void {
		this.changedAnotherData = true

		this.reports[0].recommendationsManagement =
			this.reports[0].recommendationsManagement.filter((operation, index) => {
				return operationSelected !== index
			})
	}

	public getTreeCategorySpecialWithValue(type): string {
		const treeSpecialCategory = {
						NONE: { value: 'Não se aplica'},
						PROTECTED: { value: 'Protegida'},
						THREATENED: { value: 'Ameaçada'},
						INVASIVE: { value: 'Invasora'},
						OPPORTUNIST: { value: 'Oportunista'}
				}

	 return treeSpecialCategory[type].value
	}

	public enableFieldToEdit(): void {
		this.isNotModeEdit = false
	}

	public hasChangeInput(): void {
		this.changedAnotherData = true
	}

	public limitarTamanho(event: any, size: number = 10) {
		const input = event.target as HTMLInputElement
		const maxLength = size
		if (input.value.length > maxLength) {
		  input.value = input.value.slice(0, maxLength)
		}
	  }

	public async saveEditOperationReport(): Promise<void> {
		this.disabledButton = true

		const dataEdit = this.reports[0]

		dataEdit.oldReport = this.oldReportJson

		const oldDataCopy = JSON.parse(this.oldReportJson)

		const oldAddress = oldDataCopy.address
	 const newAddress = dataEdit.address

		if (oldAddress !== newAddress) {
			this.showAddressChangeModal = true
		}

		dataEdit.recommendationsManagement.forEach(recomendation => {
			recomendation.idMongo = this.getIdsOperationManagmentInserted(recomendation.operation)
		})

		dataEdit.qrCodeImage = ''

		try {
			const response: string =
				await this.operationService.updateOperationReportArboreal(dataEdit, this.reports[0].idMongo).toPromise()

			this.disabledButton = false
			this.isNotModeEdit = true

			this.notificationService.notify(response, 200)
			if (!this.showAddressChangeModal) {
				window.location.reload()
			}
		} catch (error) {
			this.notificationService.notify(error.error.message, 200)
			console.log(error)
		}
	}

	public getTreeSpecialCategory(type) {
				const treeSpecialCategory = {
						'Não se aplica': { value: 'NONE'},
						'Protegida': { value: 'PROTECTED'},
						'Ameaçada': { value: 'THREATENED'},
						'Invasora': { value: 'INVASIVE'},
						'Oportunista': { value: 'OPPORTUNIST'}
				}

				return treeSpecialCategory[type].value
		}

	public getNumberLocationCategory(locationCategory) {
		switch (locationCategory) {
			case 'Sistema Viário':
				return 1
			case 'Parque, praça e jardim público':
				return 2
			case 'Área particular':
				return 3
			case 'Área protegida':
				return 4
		}
	}

	public getRiskClass = (value: number): any => {
		let cor = 'green'
		if (value === 1) cor = 'green'
		if (value === 2) cor = 'yellow'
		if (value === 3) cor = 'orange'
		if (value === 4) cor = 'red'

		return cor
	}

	public openSelectionModeModal() {
		removeToolTip()
		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public async exportReport() {
		const type = 'operation-report-arboreal'
		const ids = this.reports.map(report => report.idMongo)

		this.treeService.exportReport({
			type,
			ids,
			operationsData: this.dataForReports
		});

		this.openSelectionModeModal()
	}

	public async printOut() {
		this.openSelectionModeModal()

		if (this.numberOfPages.length == 0) {
			this.getPageHeight()
		}

		setTimeout(() => {
			window.print()
		}, 200)
	}

	public openSelectorHandlerOperations() {
		this.showSelectHandleOperations = true
	}

	public closeSelectorHandlerOperations(
		event: Array<{
			idMongo: string,
			operation: string,
			legalFundamentation?: string;
		}>,
		indexReport: number
	) {
		this.showSelectHandleOperations = false

		const recommendationManagementUpdated =
			event.map(managment => {
				const managmentOriginal = this.reports[indexReport].originalRecommendationsManagement.find(recomendation =>
					recomendation.idMongo === managment.idMongo
				)

				if (managmentOriginal) {
					return managmentOriginal
				} else {
					return managment
				}
			})

		this.reports[indexReport].recommendationsManagement = recommendationManagementUpdated

		this.hasChangeInput()
	}

	public closeAddressCloseModal() {
		this.showAddressChangeModal = false
		window.location.reload()
	}

	public setOperationsServiceDataToReports() {
		const sessionDataReports = getSessionOperationsServiceForReport();

		if (sessionDataReports) {
      // Se existir no sessionStorage, usar esse dado (recarregamento de página)
      this.dataForReports = sessionDataReports;
    } else {
      // Se não houver no sessionStorage, buscar no localStorage
     this.dataForReports = getOperationsServiceForReport();
		 setSessionStorageOperationsServiceForReport(this.dataForReports);
    }
	}
}
